import { z } from 'zod';

import { makeFieldSchemaFromZod } from '../utils';

/**
 * Field schema for the KaapTenantName.
 * @public
 */

// Define the Tenant object schema that will be returned when returnFullObject is true
const TenantObjectSchema = z.object({
  name: z.string().describe('Tenant name'),
});

export const KaapTenantNameFieldSchema = makeFieldSchemaFromZod(
  z.object(TenantObjectSchema.shape),
);

/**
 * UI options for the KaapTenantName.
 * @public
 */

export type KaapTenantNameUiOptions = {};

/**
 * Props for the KaapTenantName.
 * @public
 */

export type KaapTenantNameProps = typeof KaapTenantNameFieldSchema.type;

/**
 * Schema for the KaapTenantName.
 * @public
 */

export const KaapTenantNameSchema = KaapTenantNameFieldSchema.schema;
